import Phonogram from '../../assets/images/phonogram.jpg';
import MathClub from '../../assets/images/mathClub.png';

const eventData = [
    {
        img_url: Phonogram,
        event_description: "Summer Phonics Class for Kids",
        student_description: "This class is 10 sessions long from June 28 - July 28, meeting twice a week on Mondays and Wednesdays. Students will need the Kids Who Read Well Phonogram Workbook to follow along during this class. The workbook is included in the price of the class and will be shipped to your home for the standard shipping rates in your area. All fees are due upon registration. Sessions last 30-45 minutes. This class is virtual.",
    },
    {
        img_url: MathClub,
        event_description: "Middle School Math Summer Workshop",
        student_description: "This course is intended for rising 6, 7, 8, and 9th graders. The class is specifically written for students who struggle in mathematics courses during the school year. We will build a stronger foundation for middle school and 9th grade algebra. All fees are due upon required upon registration. If a payment plan is needed, please email pattonunivercity@gmail.com. Sessions last approximately 45-60 mins per day, twice a week. This class is virtual.",
    },
    {
        img_url:"https://i.imgur.com/AlDmi3x.png",
        event_description: "Golf for Girls",
        student_description: "Golf for Girls provides customized golf lessons to girls ages 6-12. An experienced golf enthusiast will instruct the young ladies on golf vocabulary, proper form, efficient swing, and overall golf etiquette. Meetings are in-person at MacGregor Park in Houston, TX.",
    }
];

export default eventData;